'use client';

import { useMemo } from 'react';

export const useUrlHash = (query: string) => {
  const hash = window.location.hash;
  const memo = useMemo(() => new URLSearchParams(hash), [hash]);

  return memo.get(query);
};
